import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "footer-menu" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "icon" }
const _hoisted_4 = { key: 0 }

import { computed } from "vue";
import { useRouter } from "vue-router";
import { svgIcon } from "@/common/components";

interface MenuListType {
  icon: string;
  label?: string;
  key: string;
  url?: string;
  active?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'footer-menu',
  props: {
    menuList: {},
    active: {},
    height: { default: "4rem" },
    background: { default: "#fff" },
    iconSize: { default: "1.75rem" }
  },
  emits: ["open"],
  setup(__props: any, { emit: __emit }) {

_useCssVars(_ctx => ({
  "v73051cff": (_ctx.background),
  "v069be978": (_ctx.height)
}))

const router = useRouter();

const emit = __emit;



const currentRoute = computed(() => router.currentRoute.value.path);

function select(menu: MenuListType) {
  if (menu.url) {
    router.push(menu.url);
    return;
  }

  emit("open", menu);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.menuList, (menu) => {
      return (_openBlock(), _createElementBlock("div", {
        key: menu.key,
        class: _normalizeClass(["menu", { active: __props.active === menu.key }]),
        onClick: ($event: any) => (select(menu))
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_unref(svgIcon), {
            icon: menu.icon,
            size: __props.iconSize
          }, null, 8, ["icon", "size"])
        ]),
        (menu.label)
          ? (_openBlock(), _createElementBlock("label", _hoisted_4, _toDisplayString(menu.label), 1))
          : _createCommentVNode("", true)
      ], 10, _hoisted_2))
    }), 128))
  ]))
}
}

})